import { Session } from "./session";

export const isLoggedIn = () => {
  return Session.isAuthenticated();
};

// export const isLoggedIn = () => {
//   return !!Session.getToken();
// };